<template>
	<slot :counter="data.comments" v-if="props.data.comments_status > 1" />
</template>

<script setup>
	const props = defineProps(['data']);
</script>
